import { createBrowserRouter } from 'react-router-dom'
import { MainLayout } from '@/components/layout/MainLayout'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { ScrollToTop } from '@/components/layout/ScrollToTop'

// Auth pages
import LoginPage from '@/pages/auth/LoginPage'
import SignupPage from '@/pages/auth/SignupPage'
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage'

// Onboarding
import OnboardingPage from '@/pages/onboarding/OnboardingPage'

// Main pages
import HomePage from '@/pages/home/HomePage'
import WorkspacesPage from '@/pages/workspaces/WorkspacesPage'
import WorkspaceCreatePage from '@/pages/workspaces/WorkspaceCreatePage'
import WorkspaceDetailPage from '@/pages/workspaces/WorkspaceDetailPage'
import WorkspaceEditPage from '@/pages/workspaces/WorkspaceEditPage'
import WorkspaceMembersPage from '@/pages/workspaces/WorkspaceMembersPage'
import WorkspaceInvitePage from '@/pages/workspaces/WorkspaceInvitePage'
import ProjectsPage from '@/pages/projects/ProjectsPage'
import ProjectCreatePage from '@/pages/projects/ProjectCreatePage'
import ProjectDetailPage from '@/pages/projects/ProjectDetailPage'
import ProjectEditPage from '@/pages/projects/ProjectEditPage'
import ProjectInvitePage from '@/pages/projects/ProjectInvitePage'
import ProjectMembersPage from '@/pages/projects/ProjectMembersPage'
import TasksPage from '@/pages/tasks/TasksPage'
import TaskCreatePage from '@/pages/tasks/TaskCreatePage'
import TaskDetailPage from '@/pages/tasks/TaskDetailPage'
import TaskEditPage from '@/pages/tasks/TaskEditPage'
import MessagesPage from '@/pages/messages/MessagesPage'
import MessageDetailPage from '@/pages/messages/MessageDetailPage'
import MessageCreatePage from '@/pages/messages/MessageCreatePage'
import MessageEditPage from '@/pages/messages/MessageEditPage'
import DocumentsPage from '@/pages/documents/DocumentsPage'
import DocumentCreatePage from '@/pages/documents/DocumentCreatePage'
import DocumentDetailPage from '@/pages/documents/DocumentDetailPage'
import DocumentEditPage from '@/pages/documents/DocumentEditPage'
import ReportsPage from '@/pages/reports/ReportsPage'
import InboxPage from '@/pages/inbox/InboxPage'
import UsersPage from '@/pages/users/UsersPage'
import UserCreatePage from '@/pages/users/UserCreatePage'
import UserDetailPage from '@/pages/users/UserDetailPage'
import UserEditPage from '@/pages/users/UserEditPage'
import SearchResultsPage from '@/pages/search/SearchResultsPage'
import HistoryPage from '@/pages/history/HistoryPage'
import NotFoundPage from '@/pages/NotFoundPage'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <>
        <ScrollToTop />
        <LoginPage />
      </>
    ),
  },
  {
    path: '/signup',
    element: (
      <>
        <ScrollToTop />
        <SignupPage />
      </>
    ),
  },
  {
    path: '/forgot-password',
    element: (
      <>
        <ScrollToTop />
        <ForgotPasswordPage />
      </>
    ),
  },
  {
    path: '/onboarding',
    element: (
      <ProtectedRoute>
        <>
          <ScrollToTop />
          <OnboardingPage />
        </>
      </ProtectedRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'workspaces',
        element: <WorkspacesPage />,
      },
      {
        path: 'workspaces/new',
        element: <WorkspaceCreatePage />,
      },
      {
        path: 'workspaces/:workspaceId',
        element: <WorkspaceDetailPage />,
      },
      {
        path: 'workspaces/:workspaceId/edit',
        element: <WorkspaceEditPage />,
      },
      {
        path: 'workspaces/:workspaceId/members',
        element: <WorkspaceMembersPage />,
      },
      {
        path: 'workspaces/:workspaceId/invite',
        element: <WorkspaceInvitePage />,
      },
      {
        path: 'projects',
        element: <ProjectsPage />,
      },
      {
        path: 'projects/new',
        element: <ProjectCreatePage />,
      },
      {
        path: 'projects/:projectId',
        element: <ProjectDetailPage />,
      },
      {
        path: 'projects/:projectId/edit',
        element: <ProjectEditPage />,
      },
      {
        path: 'projects/:projectId/invite',
        element: <ProjectInvitePage />,
      },
      {
        path: 'projects/:projectId/members',
        element: <ProjectMembersPage />,
      },
      {
        path: 'tasks',
        element: <TasksPage />,
      },
      {
        path: 'tasks/new',
        element: <TaskCreatePage />,
      },
      {
        path: 'tasks/:taskId',
        element: <TaskDetailPage />,
      },
      {
        path: 'tasks/:taskId/edit',
        element: <TaskEditPage />,
      },
      {
        path: 'messages',
        element: <MessagesPage />,
      },
      {
        path: 'messages/new',
        element: <MessageCreatePage />,
      },
      {
        path: 'messages/:messageId',
        element: <MessageDetailPage />,
      },
      {
        path: 'messages/:messageId/edit',
        element: <MessageEditPage />,
      },
      {
        path: 'documents',
        element: <DocumentsPage />,
      },
      {
        path: 'documents/new',
        element: <DocumentCreatePage />,
      },
      {
        path: 'documents/:documentId',
        element: <DocumentDetailPage />,
      },
      {
        path: 'documents/:documentId/edit',
        element: <DocumentEditPage />,
      },
      {
        path: 'reports',
        element: <ReportsPage />,
      },
      {
        path: 'inbox',
        element: <InboxPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'users/new',
        element: <UserCreatePage />,
      },
      {
        path: 'users/:userId',
        element: <UserDetailPage />,
      },
      {
        path: 'users/:userId/edit',
        element: <UserEditPage />,
      },
      {
        path: 'search',
        element: <SearchResultsPage />,
      },
      {
        path: 'history',
        element: <HistoryPage />,
      },
    ],
  },
  {
    path: '*',
    element: (
      <>
        <ScrollToTop />
        <NotFoundPage />
      </>
    ),
  },
])
